import useTranslation from "@CS/hooks/useTranslation";
import Content from './content';

import {
  Title,
  Button,
  CloseButton,
  Description,
  PopupOverlay,
  PopupContent
} from "./WelcomePopup.styles";

type WelcomePopupProps = {
  onClose: () => void;
};

export const WelcomePopup = ({ onClose }: WelcomePopupProps) => {
  const { title, description, button } = useTranslation(Content);

  return (
    <PopupOverlay>
      <PopupContent>
        <CloseButton onClick={onClose} />
        <Title>{title}</Title>
        <Description>
          {description}
        </Description>
        <Button onClick={onClose}>{button}</Button>
      </PopupContent>
    </PopupOverlay>
  );
};
